import merge from 'deepmerge';
import { combineReducers } from 'redux';

const rates = () => (state = {
  // inital states here
  rateData: null,
}, action) => {
  if (action.type === 'RATES_SUCCESS' && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
  return state;
};

export default combineReducers({
  rates: rates(),
});
